import {getUsersByLocalId} from '../../../../../crud/users_api/users';
import {getMesasByLocalId} from '../../../../../crud/management_api/mesas';  
import {getAllPedidosType} from '../../../../../crud/configuration_api/pedidos_type'; 

  export interface UsersOption {
    id: number;
    name: string;
  }

  export interface MesasOption {
    id: number;
    num: string;
  }

  export interface PedidoTypeOption {
    id: number;
    name: string;
  }
  

  export const getUsersOptions = async () => {
      const userContext = localStorage.getItem('user');
      const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
      const response = await getUsersByLocalId(localId);
      if (response) {
        const data = response.data;
        if (data) {
          const users: UsersOption[] = data.map((users:any) => {
            return {
              id: users.user_id,
              name: users.username,
            };
          });
          return [{id:0,name:"Ninguno"},...users];
        }
      }
      return [];
    };

    export const getMesasOptions = async () => {
          const userContext = localStorage.getItem('user');
          const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
          const response = await getMesasByLocalId(localId);
          if (response) {
            const data = response.data;
            if (data) {
              const mesas: MesasOption[] = data.map((mesas:any) => {
                return {
                  id: mesas.mesa_id,
                  num: mesas.mesa_number,
                };
              });
              return [{id:0,num:"Ninguno"},...mesas];
            }
          }
          return [];
        };

export const getPedidosTypeOptions = async () => {
          const response = await getAllPedidosType();
          if (response) {
            const data = response.data;
            if (data) {
              const pedidoType: PedidoTypeOption[] = data.map((pedidosType:any) => {
                return {
                  id: pedidosType.pedido_type_id,
                  name: pedidosType.pedido_type_name,
                };
              });
              return [{id:0,name:"Ninguno"},...pedidoType];
            }
          }
          return [];
        };

export function createMapFromOptions(options: any[]): Map<number, any> {
          return options.reduce((acc: Map<number, string>, option: any) => {
            acc.set(option.id, option.name);
            return acc;
          }, new Map<number, any>());
}




